export default import.meta.ROLLUP_FILE_URL_aEX_WJIy;